import m from "../../geodata/es2015/liechtensteinLow";
window.am4geodata_liechtensteinLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/liechtensteinLow.js
// module id = null
// module chunks = 